'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;
exports.default = reducer;
exports.setIsMobile = setIsMobile;
exports.getId = getId;
exports.setDelayedToast = setDelayedToast;
exports.clearDelayedToast = clearDelayedToast;

var _qim = require('qim');

var SET_IS_MOBILE = 'common/SET_IS_MOBILE';
var GET_ID = 'common/GET_ID';
var SET_DELAYED_TOAST = 'common/SET_DELAYED_TOAST';
var CLEAR_DELAYED_TOAST = 'common/CLEAR_DELAYED_TOAST';

var initialState = exports.initialState = {
  isMobile: false,
  ids: {
    default: 0
  },
  delayedToast: {
    type: 'info',
    message: null
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_IS_MOBILE:
      {
        return (0, _qim.set)(['isMobile'], true, state);
      }
    case GET_ID:
      {
        return (0, _qim.update)([['ids', action.prefix || 'default', (0, _qim.$apply)(function (id) {
          return id + 1 || 1;
        })]], state);
      }
    case SET_DELAYED_TOAST:
      {
        return (0, _qim.set)(['delayedToast'], { type: action.toastType, message: action.message }, state);
      }
    case CLEAR_DELAYED_TOAST:
      {
        return (0, _qim.set)(['delayedToast'], { type: null, message: null }, state);
      }
    default:
      {
        return state;
      }
  }
}

function setIsMobile() {
  return {
    type: SET_IS_MOBILE
  };
}

function getId(prefix) {
  return function (dispatch, getState) {
    var newId = getState().common.ids[prefix || 'default'] + 1 || 1;
    dispatch({
      type: GET_ID,
      prefix: prefix
    });

    return prefix ? '' + prefix + newId : newId;
  };
}

function setDelayedToast(_ref) {
  var type = _ref.type,
      message = _ref.message;

  return {
    type: SET_DELAYED_TOAST,
    toastType: type,
    message: message
  };
}

function clearDelayedToast() {
  return {
    type: CLEAR_DELAYED_TOAST
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/common.js
// module id = 265
// module chunks = 1